import React from "react";
//#region types
import { FormFieldProps } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import Tags from "../../tags";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

function DefaultTagFormField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const { value } = props;

  return value ? (
    <Tags
      tags={[LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Default)]}
      className={cssExports.greenTag}
    />
  ) : (
    <></>
  );
}

export default DefaultTagFormField;
